export const isBeeLocalPreviewHost = (hostname) => ['localhost', '127.0.0.1'].includes(hostname);
